import { all, takeEvery, call, put, fork } from 'redux-saga/effects';
import _ from 'lodash';
import mailActions from './actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';
import isEmpty from 'lodash/isEmpty';

const doGetMail = async (payload) => {
  let page = "1";
  let category = "";
  let archived = "/notarchived";
  if (payload.payload !== undefined) {
    page = payload.payload.page || page;
    category = payload.payload.category || category;
    archived = payload.payload.archive ? "/archived" : "/notarchived";
  }
  return await SuperFetch.post(`${apiUrls.getInboxV2}/${page}${archived}${category}?num=1000`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* getMail(payload) {
  const response = yield call(doGetMail, payload);
  if (response && !isEmpty(response)) {
    yield put(mailActions.doGetMailSucceeded(response))
  }
}

const doGetSentMail = async (payload) => {
  let page = "1";
  if (payload.payload !== undefined) {
    page = payload.payload.page || page;
  }
  return await SuperFetch.post(`${apiUrls.sentMessages}/${page}?num=1000`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* getSentMail(payload) {
  const response = yield call(doGetSentMail, payload);
  if (response && !isEmpty(response)) {
    yield put(mailActions.doGetSentMailSucceeded(response))
  }
}

const doReplyToThread = async (payload) => {
  return await SuperFetch.post(`${apiUrls.sendReplyToThread}`, payload)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* replyToThread(action) {
  const response = yield call(doReplyToThread, action.payload);
  if (response && !isEmpty(response)) {
    yield put(mailActions.doReplyToThreadSucceeded(response))
  }
}

const doStartThread = async (payload) => {
  return await SuperFetch.post(`${apiUrls.sendMessage}`, payload)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* startThread(action) {
  const response = yield call(doStartThread, action.payload);
  if (response && !isEmpty(response.message.message.hash)) {
    yield put(mailActions.doGetMail());
  }
}

const doArchiveThread = async (payload) => {
  return await SuperFetch.post(`${apiUrls.archiveThread}`, payload)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* archiveThread(action) {
  const payload = {};
  if (!_.isUndefined(action.payload.threadId)) {
    payload.data = {
      threadId: action.payload.threadId
    }
  } else {
    payload.data = {
      threads: action.payload.threads
    }
  }
  const response = yield call(doArchiveThread, payload);
  if (response && response.archiveRows[0].result === "added") {
    const category = action.payload.bucket === "Issues" ? "/category-issue" : "";
    const payload = {
      category: category
    }
    yield put(mailActions.doGetMail(payload));
    yield put(mailActions.doGetBucketCounts());
  }
}

const doUnArchiveThread = async (payload) => {
  return await SuperFetch.post(`${apiUrls.unArchiveThread}`, payload)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* unArchiveThread(action) {
  const payload = {};
  if (!_.isUndefined(action.payload.threadId)) {
    payload.data = {
      threadId: action.payload.threadId
    }
  } else {
    payload.data = {
      threads: action.payload.threads
    }
  }
  const response = yield call(doUnArchiveThread, payload);
  if (response && response.archiveRows[0].result === "removed") {
    const payload = {
      archive: true
    }
    yield put(mailActions.doGetMail(payload));
    yield put(mailActions.doGetBucketCounts());
  }
}

const doMarkThreadRead = async (payload) => {
  return await SuperFetch.post(`${apiUrls.markThreadRead}`, payload)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* markThreadRead(action) {
  const payload = {};
  if (!_.isUndefined(action.payload.threadId)) {
    payload.data = {
      threadId: action.payload.threadId
    }
  } else {
    payload.data = {
      threads: action.payload.threads
    }
  }
  const response = yield call(doMarkThreadRead, payload);
  let page = "1";
  let category = "";
  let archive = false;
  switch (action.payload.bucket) {
    case '"Inbox"':
      category = "";
      break;
    case "Issues":
      category = "/category-issue";
      archive = false;
      break;
    case "Enquiries":
      category = "/category-propertyEnquiry";
      archive = false;
      break;
    case "Archive":
      archive = true;
      break;
    default:
      category = "";
      archive = false;
  }
  if (response && response.messagesMarkedRead) {
    const payload = {
      page,
      category,
      archive
    }
    yield put(mailActions.doGetMail(payload));
    yield put(mailActions.doGetBucketCounts());
  }
}

const doGetBucketCount = async () => {
  return await SuperFetch.post(`${apiUrls.getBucketCounts}`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* getBucketCount() {
  const response = yield call(doGetBucketCount);
  if (response && !isEmpty(response)) {
    yield put(mailActions.doGetBucketCountsSucceeded(response))
  }
}

export function* filterAction() {
  yield takeEvery(mailActions.FILTER_ATTRIBUTE, function*() {});
}

export default function* rootSaga() {
  yield all([
    fork(filterAction),
    takeEvery(mailActions.DO_GET_MAIL, getMail),
    takeEvery(mailActions.DO_GET_SENT_MAIL, getSentMail),
    takeEvery(mailActions.DO_REPLY_TO_THREAD, replyToThread),
    takeEvery(mailActions.DO_START_THREAD, startThread),
    takeEvery(mailActions.DO_ARCHIVE_THREAD, archiveThread),
    takeEvery(mailActions.DO_UNARCHIVE_THREAD, unArchiveThread),
    takeEvery(mailActions.DO_MARK_THREAD_READ, markThreadRead),
    takeEvery(mailActions.DO_GET_BUCKET_COUNTS, getBucketCount),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/mail/saga.js